import React from 'react';
import Page from '../../components/Page.tsx';
import Banner from '../../components/Banner.tsx';
import FancySubtitle from '../../components/FancySubtitle.tsx';
import SpecialTitle from '../../components/SpecialTitle.tsx';
import BannerSection from './BannerSection.tsx';
import TitleContainer from './TitleContainer.tsx';

function Main() {
  return (
    <Page>
      <BannerSection>
          <Banner>
              <FancySubtitle>we will not be erased</FancySubtitle>
              <TitleContainer>
                <SpecialTitle>#trans</SpecialTitle>
                <SpecialTitle>people</SpecialTitle>
                <SpecialTitle>exist</SpecialTitle>
              </TitleContainer>
          </Banner>
        </BannerSection>
    </Page>
  );
}

export default Main;